import {create} from 'zustand';
import {persist} from 'zustand/middleware';
import {parseJwtUser} from './parseJwtUser';

interface AuthState {
  token: string | null;
  teamId: string | null;
  staffId: string | null;
  noRedirect: boolean;
  isAdmin: boolean;
  updateToken: (token: string | null, isAdmin?: boolean) => void;
  logout: () => void;
}

export const authStoreKey = '@blesk/auth';

export const bleskAuthStore = create(
  persist<AuthState>(
    (set) => ({
      token: null,
      teamId: null,
      staffId: null,
      isAdmin: false,
      noRedirect: false,
      updateToken: (token, isAdmin = false, noRedirect = false) => {
        const user = parseJwtUser(token);
        set({
          token,
          isAdmin,
          noRedirect,
          teamId: user ? user.teamId : null,
          staffId: user ? user.staffId : null,
        });
      },
      logout: () => set({token: null, teamId: null, isAdmin: false}),
    }),
    {name: authStoreKey},
  ),
);
